module.exports = __webpack_public_path__ + "static/media/gcash-right.3a95a6ed.png";